import React from 'react';
import { useVisuallyHidden } from '../../hooks/useVisuallyHidden';
export const VisuallyHidden = React.forwardRef(({ hidden = false, children }, ref) => {
    const { hiddenStyle } = useVisuallyHidden();
    return (React.createElement("div", { ref: ref, style: hidden ? hiddenStyle : null, "data-anvil-component": "VisuallyHidden" }, children));
});
//# sourceMappingURL=VisuallyHidden.js.map